export default __webpack_public_path__ + "static/media/india_dairy_market.ecbfc4417076a18422f7d52a0a0ca8d0.png";